// Generated by Melange

import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

const h1 = "font-extrabold text-3.5xl tracking-[-0.64px]";

const h2 = "font-bold text-2xl";

const h3 = "font-mediumbold text-m tracking-tight";

const h4 = "font-mediumbold text-base";

const h5 = "font-semibold text-sm";

const h6 = "font-semibold text-xs";

const paragraphLarge = "font-normal text-lg";

const paragraph = "font-normal text-base";

const paragraphSmall = "font-normal text-sm";

const caption = "text-xs";

const label = "font-mediumbold text-xs tracking-wider flex items-center uppercase";

const labelSmall = "font-semibold text-xss tracking-wider flex items-center uppercase";

const withIcon = "flex items-center select-none whitespace-nowrap";

const no_wrap = "whitespce-nowrap overflow-hidden text-ellipsis";

const Styles = {
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  h6: h6,
  paragraphLarge: paragraphLarge,
  paragraph: paragraph,
  paragraphSmall: paragraphSmall,
  caption: caption,
  label: label,
  labelSmall: labelSmall,
  withIcon: withIcon,
  no_wrap: no_wrap
};

function make(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: h1,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$H1(Props) {
  return Curry._1(make(Props.nowrap)(Props.className), Props.children);
}

const H1 = {
  make: Text$H1
};

function make$1(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: h2,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$H2(Props) {
  return Curry._1(make$1(Props.nowrap)(Props.className), Props.children);
}

const H2 = {
  make: Text$H2
};

function make$2(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: h3,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$H3(Props) {
  return Curry._1(make$2(Props.nowrap)(Props.className), Props.children);
}

const H3 = {
  make: Text$H3
};

function make$3(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: h4,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$H4(Props) {
  return Curry._1(make$3(Props.nowrap)(Props.className), Props.children);
}

const H4 = {
  make: Text$H4
};

function make$4(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (titleOpt) {
      const title = titleOpt !== undefined ? titleOpt : "";
      return function (children) {
        const className$1 = Cn.fromList({
              hd: h5,
              tl: {
                hd: Cn.on(no_wrap, nowrap),
                tl: {
                  hd: Cn.take(className),
                  tl: /* [] */0
                }
              }
            });
        return JsxRuntime.jsx("div", {
                    children: children,
                    className: className$1,
                    title: title
                  });
      };
    };
  };
}

function Text$H5(Props) {
  return Curry._2(make$4(Props.nowrap)(Props.className), Props.title, Props.children);
}

const H5 = {
  make: Text$H5
};

function make$5(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: h6,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$H6(Props) {
  return Curry._1(make$5(Props.nowrap)(Props.className), Props.children);
}

const H6 = {
  make: Text$H6
};

function make$6(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: paragraphLarge,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$PLarge(Props) {
  return Curry._1(make$6(Props.nowrap)(Props.className), Props.children);
}

const PLarge = {
  make: Text$PLarge
};

function make$7(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: paragraph,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$P(Props) {
  return Curry._1(make$7(Props.nowrap)(Props.className), Props.children);
}

const P = {
  make: Text$P
};

function make$8(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (classNameOpt) {
    const className = classNameOpt !== undefined ? classNameOpt : "text-black";
    return function (titleOpt) {
      const title = titleOpt !== undefined ? titleOpt : "";
      return function (onMouseEnterOpt) {
        const onMouseEnter = onMouseEnterOpt !== undefined ? onMouseEnterOpt : (function (param) {
              
            });
        return function (onMouseLeaveOpt) {
          const onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : (function (param) {
                
              });
          return function (children) {
            const className$1 = Cn.fromList({
                  hd: paragraphSmall,
                  tl: {
                    hd: Cn.on(no_wrap, nowrap),
                    tl: {
                      hd: className,
                      tl: /* [] */0
                    }
                  }
                });
            return JsxRuntime.jsx("div", {
                        children: children,
                        className: className$1,
                        title: title,
                        onMouseEnter: onMouseEnter,
                        onMouseLeave: onMouseLeave
                      });
          };
        };
      };
    };
  };
}

function Text$PSmall(Props) {
  return Curry._4(make$8(Props.nowrap)(Props.className), Props.title, Props.onMouseEnter, Props.onMouseLeave, Props.children);
}

const PSmall = {
  make: Text$PSmall
};

function make$9(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: caption,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$Caption(Props) {
  return Curry._1(make$9(Props.nowrap)(Props.className), Props.children);
}

const Caption = {
  make: Text$Caption
};

function make$10(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: label,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$Label(Props) {
  return Curry._1(make$10(Props.nowrap)(Props.className), Props.children);
}

const Label = {
  make: Text$Label
};

function make$11(nowrapOpt) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  return function (className) {
    return function (children) {
      const className$1 = Cn.fromList({
            hd: labelSmall,
            tl: {
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            }
          });
      return JsxRuntime.jsx("div", {
                  children: children,
                  className: className$1
                });
    };
  };
}

function Text$LabelSmall(Props) {
  return Curry._1(make$11(Props.nowrap)(Props.className), Props.children);
}

const LabelSmall = {
  make: Text$LabelSmall
};

function make$12(className) {
  return function (nowrapOpt) {
    const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
    return function (fontWeightOpt) {
      return function (children) {
        const className$1 = Cn.fromList({
              hd: Cn.on(no_wrap, nowrap),
              tl: {
                hd: Cn.take(className),
                tl: /* [] */0
              }
            });
        return JsxRuntime.jsx("span", {
                    children: children,
                    className: className$1
                  });
      };
    };
  };
}

function Text$Span(Props) {
  return Curry._2(make$12(Props.className)(Props.nowrap), Props.fontWeight, Props.children);
}

const Span = {
  make: Text$Span
};

function make$13(icon) {
  return function (text) {
    return function (className) {
      return function (marginOpt) {
        const margin = marginOpt !== undefined ? marginOpt : "m-2";
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: icon,
                            className: margin
                          }),
                      text
                    ],
                    className: Cn.fromList({
                          hd: withIcon,
                          tl: {
                            hd: Cn.take(className),
                            tl: /* [] */0
                          }
                        })
                  });
      };
    };
  };
}

function Text$TextWithIcon(Props) {
  return Curry._2(make$13(Props.icon)(Props.text), Props.className, Props.margin);
}

const TextWithIcon = {
  make: Text$TextWithIcon
};

export {
  Styles ,
  H1 ,
  H2 ,
  H3 ,
  H4 ,
  H5 ,
  H6 ,
  PLarge ,
  P ,
  PSmall ,
  Caption ,
  Label ,
  LabelSmall ,
  Span ,
  TextWithIcon ,
}
/* react/jsx-runtime Not a pure module */
